import React from "react"
import Container from 'react-bootstrap/Container';

const AboutUs = () => {
    return (<Container style={{display: 'flex', justifyContent: 'center', padding: '50px 0'}}>
        <h1>About Us Page</h1>
    </Container>)
}

export default AboutUs